import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_descriptions, {
          class: "margin-top",
          title: "系统设置",
          column: 1,
          size: "medium"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "客户编码" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.user.code), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_descriptions_item, { label: "绑定邮箱登录" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.user.email ? $setup.user.email : '暂无绑定账号') + " ", 1 /* TEXT */),
                ($setup.user.email)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "warning",
                      size: "small",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openDialog('修改密码')))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("修改密码")
                      ])),
                      _: 1 /* STABLE */,
                      __: [11]
                    }))
                  : _createCommentVNode("v-if", true),
                ($setup.user.email)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "warning",
                      size: "small",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openDialog('修改邮箱')))
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("修改邮箱")
                      ])),
                      _: 1 /* STABLE */,
                      __: [12]
                    }))
                  : _createCommentVNode("v-if", true),
                (!$setup.user.email)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      size: "small",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openDialog('添加邮箱')))
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("添加邮箱")
                      ])),
                      _: 1 /* STABLE */,
                      __: [13]
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_descriptions_item, { label: "授权凭证(Token)" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.user.token ? $setup.user.token : '暂无'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_descriptions_item, { label: "每天短信提醒：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  content: '是否开启: ' + ($setup.user.is_subscribe == 1 ? '开启' : '关闭'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: $setup.user.is_subscribe,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.user.is_subscribe) = $event)),
                      style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                      "active-value": 1,
                      "inactive-value": 0,
                      onChange: $setup.changeSubscribe
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["content"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: $setup.dialogVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.dialogVisible) = $event)),
      title: $setup.title,
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      class: "dialog-login",
      "append-to-body": true,
      width: "600px",
      height: "4000px",
      onClose: $setup.dialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.dialogVisible = false))
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("取消")
          ])),
          _: 1 /* STABLE */,
          __: [14]
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.handleSubmit
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("提交")
          ])),
          _: 1 /* STABLE */,
          __: [15]
        })
      ]),
      default: _withCtx(() => [
        ($setup.title === '修改密码' || $setup.title === '修改邮箱')
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: "注意：以下操作 修改密码,修改邮箱 会自动退出重新登录",
              type: "warning",
              closable: false
            }))
          : _createCommentVNode("v-if", true),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: $setup.formData,
          rules: $setup.formRules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            ($setup.title === '添加邮箱')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_form_item, {
                    label: "邮箱",
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $setup.formData.email,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.email) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "密码",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $setup.formData.password,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.password) = $event)),
                        type: "password",
                        "show-password": ""
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($setup.title === '修改密码')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_form_item, {
                    label: "新密码",
                    prop: "newPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $setup.formData.newPassword,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formData.newPassword) = $event)),
                        type: "password",
                        "show-password": ""
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "确认密码",
                    prop: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $setup.formData.confirmPassword,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formData.confirmPassword) = $event)),
                        type: "password",
                        "show-password": ""
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($setup.title === '修改邮箱')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "邮箱",
                  prop: "email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.formData.email,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formData.email) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model", "rules"])
      ]),
      _: 1 /* STABLE */,
      __: [16]
    }, 8 /* PROPS */, ["modelValue", "title"])
  ], 64 /* STABLE_FRAGMENT */))
}